__turbopack_context__.v({
  "contact": "page-module-scss-module__ydi3ra__contact",
  "container": "page-module-scss-module__ydi3ra__container",
  "content": "page-module-scss-module__ydi3ra__content",
  "header": "page-module-scss-module__ydi3ra__header",
  "page": "page-module-scss-module__ydi3ra__page",
  "section": "page-module-scss-module__ydi3ra__section",
  "updated": "page-module-scss-module__ydi3ra__updated",
});
